import { Controller } from "@hotwired/stimulus"
import ToastController from "@controllers/toast_controller"

// Connects to data-controller="change-password-form"
export default class extends Controller {
  connect() {
    console.log("Change password form controller connected")

    // Initialize toast controller
    this.toast = new ToastController()

    // Track inputs for validation
    this.trackInputs()

    // Disable submit button initially
    this.updateSubmitButton()
  }

  trackInputs() {
    const inputs = this.element.querySelectorAll('input[name]:not([type="hidden"])')
    inputs.forEach(input => {
      input.addEventListener('input', () => this.checkFormValidity())
      input.addEventListener('change', () => this.checkFormValidity())
    })
  }

  checkFormValidity() {
    const currentPassword = this.element.querySelector('input[name="current_password"]')
    const newPassword = this.element.querySelector('input[name="new_password"]')
    const confirmPassword = this.element.querySelector('input[name="password_confirmation"]')

    let isValid = true

    // Check if current password is required and filled
    if (currentPassword && !currentPassword.value) {
      isValid = false
    }

    // Check if new password is filled and at least 8 characters
    if (!newPassword.value || newPassword.value.length < 8) {
      isValid = false
    }

    // Check if confirmation matches new password
    if (!confirmPassword.value || confirmPassword.value !== newPassword.value) {
      isValid = false
    }

    this.updateSubmitButton(isValid)
  }

  updateSubmitButton(enabled = false) {
    const submitButton = this.element.querySelector('button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = !enabled
    }
  }

  submit(event) {
    event.preventDefault()

    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]').content

    // Collect form data
    const currentPassword = this.element.querySelector('input[name="current_password"]')
    const newPassword = this.element.querySelector('input[name="new_password"]')
    const confirmPassword = this.element.querySelector('input[name="password_confirmation"]')

    // Client-side validation
    if (newPassword.value.length < 8) {
      this.toast.error('Password must be at least 8 characters')
      return
    }

    if (newPassword.value !== confirmPassword.value) {
      this.toast.error('New password and confirmation do not match')
      return
    }

    // Build request body
    const data = {
      new_password: newPassword.value,
      password_confirmation: confirmPassword.value
    }

    if (currentPassword) {
      data.current_password = currentPassword.value
    }

    // Disable button during submit
    this.updateSubmitButton(false)

    // Submit via Fetch API with JSON
    fetch(this.element.action, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    })
    .then(response => {
      if (response.ok) {
        // Show success toast and redirect to settings
        this.toast.success('Password updated successfully')
        setTimeout(() => {
          window.location.href = this.element.dataset.redirectUrl || '/participants/settings'
        }, 1000)
      } else {
        return response.json().then(data => {
          const errorMessage = data.errors ? data.errors.join(', ') : 'Failed to update password'
          this.toast.error(errorMessage)
          // Re-enable button on error
          this.updateSubmitButton(true)
        })
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.toast.error('An error occurred while updating password. Please try again.')
      // Re-enable button on error
      this.updateSubmitButton(true)
    })
  }
}
